// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:DLMRfx */\n.dGC5j{border-bottom:1px solid var(--audio-stroke-default);padding:var(--audio-spacing-24) var(--audio-spacing-16);width:100%}.jn9gb{padding:var(--audio-spacing-24) var(--audio-spacing-16) var(--audio-spacing-48)}@media (min-width:768px){.jn9gb,.dGC5j{padding-left:var(--audio-spacing-24);padding-right:var(--audio-spacing-24)}}@media (min-width:1280px){.dGC5j{padding-bottom:var(--audio-spacing-64);padding-top:var(--audio-spacing-64)}.jn9gb{padding-bottom:var(--audio-spacing-80)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroBand": "dGC5j",
	"contentBand": "jn9gb"
};
export default ___CSS_LOADER_EXPORT___;
